import axiosInstance from "../utils/axios";

const BASE_URL = "/cms/v1";

async function getComponentConfiguration(merchantCode: string) {
  return axiosInstance.get(`${BASE_URL}/components/transaction-details`, {
      params: { merchantCode }
    }
  )
}

export {
    getComponentConfiguration,
}